<template>
  <div class="mainLayout__root">
    <div class="flex flex-col flex-1">
      <Header />
      <Transition mode="out-in" @after-leave="onAfterLeave">
        <main :key="locale">
          <slot name="default"></slot>
        </main>
      </Transition>
      <Footer />
    </div>
  </div>
</template>

<script setup lang="ts">
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { useParallax } from '@/composables/ui/useParallax.ts'
import { useI18n } from 'vue-i18n'
import { watch } from 'vue'

const { locale } = useI18n()

const { initialize, uninitialize } = useParallax()

const onAfterLeave = () => {
  requestAnimationFrame(() => {
    initialize()
  })
}

watch(locale, () => {
  uninitialize() // Ensure previously attached handlers are removed
})
</script>
